// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Ra-_","col":"Table_col__2c8_A","fulfillmentStatus":"Table_fulfillmentStatus__3RXLr","emailCol":"Table_emailCol__4xgWS"};